import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MedRecordCategoryTable from './MedRecordCategoryTable';
import MedRecordCategoryModal from './MedRecordCategoryModal';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import paths from 'routes/paths';

const MedRecordCategory = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [medrecval, setMedRecVal] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleOpenAddModal = () => {
        setMedRecVal(null);
        setEditTrigger(0);
        setShowModal(true);
    };

    const callAnotherChildMethod = () => {
        setTrigger((prev) => prev + 1);
    };

    const callAnotherEditChildMethod = (original) => {
        setMedRecVal(original);
        setEditTrigger((prev) => prev + 1);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Med-Record-Category', href: paths.medRecordCategory, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Medical Record Category</h5>
                        </Card.Header>
                        <Card.Body>
                            <MedRecordCategoryTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <MedRecordCategoryModal
                show={showModal}
                onHide={() => setShowModal(false)}
                medrecval={medrecval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default MedRecordCategory;

